import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}

// Surface tile bound to the --ws tile tokens. `interactive` adds a subtle hover
// lift + elevation for clickable cards (e.g. week tiles on the Dashboard).
// forwardRef (WIP-007): dialogs built from `<Card role="dialog">` need a DOM
// ref to focus-trap themselves (see useFocusTrap) — this is otherwise an
// unchanged, backward-compatible primitive.
const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { interactive = false, className = '', children, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      className={`rounded-xl border border-ws-tile-border bg-ws-tile shadow-sm ${
        interactive
          ? 'ws-lift hover:shadow-lg hover:border-ws-border-strong cursor-pointer'
          : ''
      } ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Card;
